/** This is a Set-like structure that automatically removes old keys.
 * @param {number} ttl - Time to live for each key in milliseconds. Default is 30000 (30 seconds).
 * @param {number} cleanupInterval - Interval for periodic cleanup in milliseconds. Default is 10000 (10 seconds).
 */
export default function AutoClearingSet(ttl = 30000, cleanupInterval = 10000) {
  const map = new Map();
  let timeoutId;

  const cleanup = () => {
    const now = Date.now();
    map.forEach((timestamp, key) => {
      if (now - timestamp >= ttl) {
        map.delete(key);
      }
    });
    if (map.size > 0) {
      timeoutId = setTimeout(cleanup, cleanupInterval);
    } else {
      timeoutId = null;
    }
  };

  this.add = (key) => {
    map.set(key, Date.now());
    if (!timeoutId) {
      timeoutId = setTimeout(cleanup, ttl + cleanupInterval);
    }
  };

  this.has = key => map.has(key);

  this.delete = key => map.delete(key);

  this.clear = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    map.clear();
  };
}
